// assets/upside-fbt.js
// Simon 2026-10-02 (option B): our own "Frequently Bought Together" in the product buy box.
// Lists come from assets/upside-fbt.json, rebuilt every day from our orders by
// 1_upside-drinks/tools/nutrition-facts/scripts/card_facts.mjs:
// same brand first (max 2), then products really bought together with this one.
// Each product starts on its most popular format (upside-card-facts.json, field 5), with
// size pills to switch. One button adds the checked products, then opens the cart.
// Simon 2026-10-03 (Rebuy replacement): every online product has a list (card_facts.mjs falls back to
// the best sellers of its category collection); if a list still gives fewer than 2 products here (region,
// stock), the "More like this" category collection fills it. The Rebuy FBT block (136939) is removed from
// templates/product.json. Cart calls go through assets/upside-cart-bridge.js (window.UDCartBridge), and our
// adds carry the hidden line property _ud_src ('fbt', 'also', 'more-like-this', 'recent') for attribution.
(function () {
  'use strict';
  if (window.__UD_FBT__) return;
  window.__UD_FBT__ = true;

  var me = document.currentScript;
  var LISTS_URL = me && me.getAttribute('data-lists');
  var FACTS_URL = me && me.getAttribute('data-facts');
  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var T = FR
    ? { title: 'Souvent achetés ensemble', total: 'Prix total :', add: 'Ajouter au panier', adding: 'Ajout…', added: 'Ajouté !', addShort: 'Ajouter', also: 'Les clients ont aussi acheté' }
    : { title: 'Frequently Bought Together', total: 'Total Price:', add: 'Add to cart', adding: 'Adding…', added: 'Added!', addShort: 'Add to cart', also: 'Customers also bought' };

  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m || !LISTS_URL) return;
  var HANDLE = decodeURIComponent(m[1]); // replaced by the English handle once the lists load
  var FRMAP = {}; // en -> fr handle (only when translated)
  function loc(h) { return (FR && FRMAP[h]) || h; } // handle to use in /fr/ URLs

  function region() {
    var v = '';
    try { v = localStorage.getItem('ecomific_region') || localStorage.getItem('region') || ''; } catch (e) {}
    if (!v) { var c = document.cookie.match(/(?:^|; )(?:ecomific_region|region)=([^;]*)/); v = c ? decodeURIComponent(c[1]) : ''; }
    v = String(v).trim().toLowerCase();
    return v === 'east' || v === 'west' ? v : '';
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  // Regional stock: a variant can be in stock in Canada (Shopify "available") but at 0 in the
  // customer's warehouse region; the cart then removes it. Same service and rules as
  // ecomific-cart-reconcile.js. Cached 30 min in sessionStorage. No region / service down = ok.
  // read when used: the theme defines the endpoint after these deferred scripts run
  function invUrl() {
    var c = window.ecomificAvailabilityConfig;
    return (c && (c.endpointBase || c.inventoryApiBase)) || window.ECOMIFIC_INVENTORY_ENDPOINT_URL || '';
  }
  var invMem = {};
  function regionalOk(variantId) {
    var reg = region();
    if (!invUrl() || !reg) return Promise.resolve(true);
    var k = 'udinv:' + variantId + ':' + reg;
    if (invMem[k]) return invMem[k];
    try {
      var c = JSON.parse(sessionStorage.getItem(k) || 'null');
      if (c && Date.now() - c.t < 30 * 60 * 1000) return (invMem[k] = Promise.resolve(c.ok));
    } catch (e) {}
    return (invMem[k] = fetch(invUrl() + '?variant_id=' + encodeURIComponent(variantId) + '&region=' + encodeURIComponent(reg), { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (a) {
        if (!a || a.ok !== true) return true;
        var nat = a.available_for_sale === true && (a.tracked === false || a.inventory_policy === 'CONTINUE');
        var ok = a.available === true && (nat || !isFinite(a.quantity) || a.quantity > 0);
        try { sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), ok: ok })); } catch (e) {}
        return ok;
      }).catch(function () { return true; }));
  }
  // keep only the variants the customer's region can ship (p.variants filtered in place)
  function regionalize(p) {
    if (!p) return Promise.resolve(null);
    var av = p.variants.filter(function (v) { return v.available; });
    return Promise.all(av.map(function (v) { return regionalOk(v.id); })).then(function (oks) {
      var keep = av.filter(function (v, i) { return oks[i]; });
      if (!keep.length) return null;
      p.variants = p.variants.map(function (v) { return keep.indexOf(v) > -1 ? v : Object.assign({}, v, { available: false }); });
      return p;
    });
  }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function packCount(t) {
    t = String(t || '').toLowerCase();
    if (/^1\s*(can|canette)\b/.test(t)) return 1;
    var n = t.match(/^(\d+)/); return n ? parseInt(n[1], 10) : 1;
  }
  function label(t) { return String(t).replace(/\s*\(.*?\)\s*/g, ' ').trim(); }
  function getJSON(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r.status; return r.json(); }); }

  var css = [
    '.ud-fbt{margin:4px 0 14px;padding:14px 16px;border:1px solid #e5e7ee;border-radius:10px;font-family:inherit}',
    '.ud-fbt__title{font-size:18px;font-weight:600;margin:0 0 10px;line-height:1.3}',
    '.ud-fbt__top{display:flex;flex-wrap:wrap;align-items:center;gap:10px 18px}',
    '.ud-fbt__imgs{display:flex;align-items:center;gap:8px;flex:0 1 auto}',
    '.ud-fbt__imgs a{display:block}',
    '.ud-fbt__imgs img{height:64px;width:auto;max-width:80px;object-fit:contain;display:block}',
    '.ud-fbt__imgs img.is-off{opacity:.25}',
    '.ud-fbt__plus{font-size:13px;color:#6b7280}',
    '.ud-fbt__act{flex:1 1 200px;display:flex;flex-direction:column;align-items:stretch;gap:6px}',
    '.ud-fbt__total{text-align:center;font-size:15px}',
    '.ud-fbt__total b{font-weight:700;margin-right:6px}',
    '.ud-fbt__total s{color:#9aa0a6;margin-left:6px;font-size:13px}',
    '.ud-fbt__btn{width:100%;height:40px;border:1.5px solid #37446E;background:#fff;color:#37446E;font-weight:700;font-size:14px;letter-spacing:.03em;text-transform:uppercase;border-radius:3px;cursor:pointer}',
    '.ud-fbt__btn:hover{background:#f3f4f8}',
    '.ud-fbt__btn[disabled]{opacity:.5;cursor:default}',
    '.ud-fbt__rows{margin-top:10px}',
    '.ud-fbt__row{display:flex;align-items:center;gap:8px 10px;padding:7px 0;border-top:1px solid #f0f1f4;font-size:13px;line-height:1.35}',
    '.ud-fbt__row input{width:17px;height:17px;accent-color:#37446E;flex:0 0 auto;margin:0;cursor:pointer}',
    '.ud-fbt__name{flex:0 1 auto;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
    '.ud-fbt__name a{color:inherit;text-decoration:underline}',
    '.ud-fbt__price{flex:0 0 auto;white-space:nowrap}',
    '.ud-fbt__price s{color:#9aa0a6;margin-left:4px;font-size:12px}',
    '.ud-fbt__price.is-sale span{color:#c0392b}',
    '.ud-fbt__pills{display:flex;gap:4px;flex:0 0 auto;margin-left:auto;justify-content:flex-start}',
    '.ud-fbt__pill{font-family:Arial,Helvetica,sans-serif;font-size:11px;line-height:1;padding:5px 8px;border:1px solid #d6d9e0;border-radius:12px;background:#fff;color:#37446E;cursor:pointer;white-space:nowrap}',
    '.ud-fbt__pill.is-on{background:#37446E;border-color:#37446E;color:#fff}',
    '.ud-fbt__row.is-off .ud-fbt__name,.ud-fbt__row.is-off .ud-fbt__price{opacity:.45}',
    '@media (max-width:768px){.ud-fbt__row{flex-wrap:wrap}.ud-fbt__name{white-space:normal}.ud-fbt__pills{flex:1 1 100%;margin-left:27px}.ud-fbt__act{flex:1 1 100%}}'
  ].join('');

  var state = null; // {items:[{p, v, on}], el}

  function pickVariant(p, facts, en) {
    var avail = p.variants.filter(function (v) { return v.available; });
    if (!avail.length) return null;
    var f = facts && facts[en || p.handle];
    if (f && f[4]) { for (var i = 0; i < avail.length; i++) if (avail[i].id === f[4]) return avail[i]; }
    var packs = avail.filter(function (v) { return packCount(v.title) > 1; });
    return (packs[0] || avail[0]);
  }
  function currentPageVariant(p) {
    var inp = document.querySelector('[id$="__main"] form[action*="/cart/add"] [name="id"]');
    var id = inp && parseInt(inp.value, 10);
    if (!id) { var q = new URLSearchParams(location.search).get('variant'); id = q && parseInt(q, 10); }
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === id) return p.variants[i];
    return p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
  }

  function render() {
    var s = state, el = s.el, total = 0, compare = 0, n = 0;
    var imgs = [], rows = [];
    s.items.forEach(function (it, i) {
      var v = it.v, p = it.p;
      if (it.on) { total += v.price; compare += (v.compare_at_price > v.price ? v.compare_at_price : v.price); n++; }
      var src = (v.featured_image && v.featured_image.src) || p.featured_image;
      imgs.push((i ? '<span class="ud-fbt__plus">+</span>' : '') +
        '<a href="' + ROOT + 'products/' + p.handle + '"><img class="' + (it.on ? '' : 'is-off') + '" src="' + img(src, 160) + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy"></a>');
      var pills = p.variants.filter(function (x) { return x.available || x.id === v.id; }).map(function (x) {
        return '<button type="button" class="ud-fbt__pill' + (x.id === v.id ? ' is-on' : '') + '" data-i="' + i + '" data-v="' + x.id + '">' + label(x.title) + '</button>';
      });
      var sale = v.compare_at_price > v.price;
      rows.push('<div class="ud-fbt__row' + (it.on ? '' : ' is-off') + '">' +
        '<input type="checkbox" data-i="' + i + '"' + (it.on ? ' checked' : '') + ' aria-label="' + p.title.replace(/"/g, '&quot;') + '">' +
        '<span class="ud-fbt__name"><a href="' + ROOT + 'products/' + p.handle + '">' + p.title + '</a></span>' +
        '<span class="ud-fbt__price' + (sale ? ' is-sale' : '') + '"><span>' + money(v.price) + '</span>' + (sale ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '</span>' +
        (pills.length > 1 ? '<span class="ud-fbt__pills">' + pills.join('') + '</span>' : '<span class="ud-fbt__pills">' + pills.join('') + '</span>') +
        '</div>');
    });
    el.innerHTML = '<p class="ud-fbt__title">' + T.title + '</p>' +
      '<div class="ud-fbt__top"><div class="ud-fbt__imgs">' + imgs.join('') + '</div>' +
      '<div class="ud-fbt__act"><div class="ud-fbt__total"><b>' + T.total + '</b>' + money(total) + (compare > total ? '<s>' + money(compare) + '</s>' : '') + '</div>' +
      '<button type="button" class="ud-fbt__btn"' + (n ? '' : ' disabled') + '>' + T.add + (n > 1 ? ' (' + n + ')' : '') + '</button></div></div>' +
      '<div class="ud-fbt__rows">' + rows.join('') + '</div>';
    alignPills(0);
  }

  // Simon 2026-10-02: every pill group as wide as the widest, so a lone pill sits under the first pill of the others
  function alignPills(tries) {
    var ps = state.el.querySelectorAll('.ud-fbt__pills'), w = 0, i;
    for (i = 0; i < ps.length; i++) { ps[i].style.minWidth = ''; w = Math.max(w, ps[i].offsetWidth); }
    if (!w) { if (tries < 20) setTimeout(function () { alignPills(tries + 1); }, 200); return; }
    if (window.innerWidth <= 768) return;
    for (i = 0; i < ps.length; i++) ps[i].style.minWidth = w + 'px';
  }

  function onClick(e) {
    var t = e.target;
    if (t.classList.contains('ud-fbt__pill')) {
      e.preventDefault();
      var it = state.items[+t.getAttribute('data-i')], id = +t.getAttribute('data-v');
      it.v = it.p.variants.filter(function (x) { return x.id === id; })[0] || it.v;
      if (+t.getAttribute('data-i') === 0) it.pinned = true;
      render();
    } else if (t.matches('input[type=checkbox]')) {
      state.items[+t.getAttribute('data-i')].on = t.checked;
      render();
    } else if (t.classList.contains('ud-fbt__btn')) {
      e.preventDefault();
      addAll(t);
    }
  }

  function addAll(btn) {
    var items = state.items.filter(function (it) { return it.on && it.v.available; }).map(function (it) { return { id: it.v.id, quantity: 1 }; });
    if (!items.length) return;
    btn.disabled = true; btn.textContent = T.adding;
    addItems(items, 'fbt')
      .then(function () {
        btn.textContent = T.added;
        try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: items } })); } catch (e) {}
        openCart();
        setTimeout(function () { btn.disabled = false; render(); }, 1800);
      })
      .catch(function () { btn.disabled = false; btn.textContent = T.add; });
  }

  function syncThisItem() {
    if (!state || state.items[0].pinned) return;
    var v = currentPageVariant(state.items[0].p);
    if (v && v.id !== state.items[0].v.id) { state.items[0].v = v; state.items[0].on = !!v.available; render(); }
  }

  // Category fallback = the "More like this" collections (sections/more-products-collection.liquid puts the
  // product's category collections, smallest first, in data-ud-cands). In-stock products, collection order.
  function categoryFill(skip) {
    var hdr = document.querySelector('[id$="__more-products-collection"] [data-ud-cands]');
    var cands = ((hdr && hdr.getAttribute('data-ud-cands')) || '').split(',').filter(Boolean);
    if (!cands.length) return Promise.resolve([]);
    return getJSON(ROOT + 'collections/' + cands[0] + '/products.json?limit=30').then(function (d) {
      return (d.products || []).filter(function (p) { return (p.variants || []).some(function (v) { return v.available; }); })
        .map(function (p) { return enOf(p.handle); })
        .filter(function (h) { return skip.indexOf(h) < 0; }).slice(0, 6);
    }).catch(function () { return []; });
  }

  function start(lists, facts) {
    FRMAP = lists._fr || {};
    if (FR) { for (var en in FRMAP) if (FRMAP[en] === HANDLE) { HANDLE = en; break; } }
    var raw = lists[HANDLE] || [];
    var reg = region();
    var handles = raw.map(function (x) { var a = x.split('|'); return { h: a[0], r: a[1] || '' }; })
      .filter(function (x) { return !x.r || !reg || (x.r === 'e' ? reg === 'east' : reg === 'west'); })
      .map(function (x) { return x.h; });
    var wanted = [HANDLE].concat(handles.slice(0, 6));
    var fetchP = function (h) { return getJSON(ROOT + 'products/' + loc(h) + '.js').then(regionalize).catch(function () { return null; }); };
    return Promise.all(wanted.map(fetchP))
      .then(function (ps) {
        var main = ps[0];
        if (!main) return [];
        var mv = currentPageVariant(main);
        if (!mv) return [];
        // a page format the region cannot ship stays visible but unchecked
        var items = [{ p: main, v: mv, on: !!mv.available, en: HANDLE }];
        var fill = function (ps, hs) {
          for (var i = 0; i < ps.length && items.length < 4; i++) {
            var p = ps[i]; if (!p || !p.available) continue;
            if (items.some(function (it) { return it.p.id === p.id; })) continue;
            var v = pickVariant(p, facts, hs[i]); if (!v) continue;
            items.push({ p: p, v: v, on: true, en: hs[i] });
          }
        };
        fill(ps.slice(1), wanted.slice(1));
        if (items.length >= 4) return items;
        // Simon 2026-10-03: not enough from the list (new product, region, stock): best of its category
        return categoryFill(wanted).then(function (more) {
          if (!more.length) return items;
          return Promise.all(more.map(fetchP)).then(function (ps2) { fill(ps2, more); return items; });
        });
      })
      .then(function (items) {
        if (!items || !items.length || !items[0].p) return [];
        if (items.length < 2) return [];
        var anchor = document.querySelector('[id$="__main"] [data-rebuy-id="136939"]');
        var block = anchor && (anchor.closest('.shopify-block') || anchor);
        var host = document.querySelector('[id$="__main"] [data-ecomific-pdp-status]');
        var el = document.createElement('div');
        el.className = 'ud-fbt';
        if (block && block.parentNode) { block.parentNode.insertBefore(el, block); block.style.display = 'none'; }
        else if (host) {
          var row = host.closest('.ecomific-pdp-controls-row') || host.parentNode, after = row;
          document.querySelectorAll('[id$="__main"] [data-product-blocks] > *').forEach(function (n) { if (n.querySelector('input[name="selling_plan"], [class*="selling-plan"], [class*="selling_plan"]')) after = n; });
          var acc = document.querySelector('[id$="__main"] .ud-acc');
          if (acc && acc.previousElementSibling === after) after.parentNode.insertBefore(el, acc); else after.parentNode.insertBefore(el, after.nextSibling);
        }
        else return [];
        state = { items: items, el: el };
        el.addEventListener('click', onClick);
        el.addEventListener('change', onClick);
        render();
        document.addEventListener('change', function (e) { if (!el.contains(e.target)) setTimeout(syncThisItem, 60); }, true);
        // Rebuy may (re)inject its widget later: keep it hidden while ours is shown
        new MutationObserver(function () {
          var w = document.querySelector('[id$="__main"] [data-rebuy-id="136939"]');
          var b = w && (w.closest('.shopify-block') || w);
          if (b && b.style.display !== 'none') b.style.display = 'none';
        }).observe(document.body, { childList: true, subtree: true });
        return items.map(function (it) { return it.en; });
      });
  }

  // ---------- "Customers also bought" row under the product (Simon 2026-10-02) ----------
  // From assets/upside-also.json: products really bought together with this one (any brand,
  // weighted so basket fillers do not win), minus what the bundle above already shows.
  // Simon 2026-10-03: ONE style system for every section under the buy box (Customer Reviews, Customers also bought,
  // More like this, Recently viewed, any future one): same width, side padding, heading and spacing between sections.
  // Defined only here. Product rows use .ud-pdp-section + .ud-pdp-section__title (cardRow below); the Judge.me
  // reviews widget is pulled onto the same rules by selector (its own CSS is centered and larger).
  var JDG = '[id^="shopify-section-template"] .jdgm-rev-widg', JDGT = JDG + ' .jdgm-rev-widg__title';
  var cssSection = [
    '.ud-pdp-section,' + JDG + '{max-width:1400px!important;margin:0 auto 36px!important;padding:0 20px!important;box-sizing:border-box!important;border:0!important}',
    JDG + '{margin-top:40px!important}',
    // the theme wraps the reviews app in .index-section (60px padding) > .page-width (40px sides) > .jdgm-widget (1200px): flatten them
    '[id^="shopify-section-template"]:has(.jdgm-rev-widg) .index-section{padding:0!important;margin:0!important}',
    '[id^="shopify-section-template"] .page-width:has(.jdgm-rev-widg){max-width:none!important;padding:0!important}',
    '[id^="shopify-section-template"] .jdgm-widget.jdgm-review-widget{max-width:none!important;margin:0!important}',
    '.ud-pdp-section__title,' + JDGT + '{font-family:inherit!important;font-size:22px!important;font-weight:600!important;line-height:1.3!important;color:#202A36!important;text-align:left!important;letter-spacing:normal!important;text-transform:none!important;margin:0!important;padding:0!important}',
    JDGT + '{margin:0 0 12px!important}',
    '@media (max-width:768px){.ud-pdp-section,' + JDG + '{padding:0 16px!important;margin-bottom:28px!important}.ud-pdp-section__title,' + JDGT + '{font-size:18px!important}}'
  ].join('');
  var cssAlso = [
    '.ud-also__head{display:flex;align-items:center;justify-content:space-between;margin:0 0 12px}',
    '.ud-also__nav button{width:34px;height:34px;border-radius:50%;border:1px solid #d6d9e0;background:#fff;color:#37446E;font-size:16px;cursor:pointer;margin-left:6px}',
    '.ud-also__row{display:flex;gap:14px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;padding-bottom:4px}',
    '.ud-also__row::-webkit-scrollbar{display:none}',
    '.ud-also__card{flex:0 0 190px;scroll-snap-align:start;border:1px solid #eef0f4;border-radius:10px;padding:10px;display:flex;flex-direction:column;background:#fff}',
    '.ud-also__img{display:block;aspect-ratio:1/1;margin-bottom:8px}',
    '.ud-also__img img{width:100%;height:100%;object-fit:contain}',
    '.ud-also__name{font-size:13px;line-height:1.35;color:inherit;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:35px}',
    '.ud-also__price{font-size:14px;font-weight:700;margin-top:6px}',
    '.ud-also__price s{color:#9aa0a6;font-weight:400;font-size:12px;margin-left:4px}',
    '.ud-also__price.is-sale span{color:#c0392b}',
    '.ud-also__fmt{font-family:Arial,Helvetica,sans-serif;font-size:11px;color:#8a8f98;margin-top:2px;min-height:13px}',
    '.ud-also__pills{display:flex;flex-wrap:wrap;gap:4px;margin-top:7px}',
    '.ud-also__pill{font-family:Arial,Helvetica,sans-serif;font-size:10.5px;line-height:1;padding:4px 7px;border:1px solid #d6d9e0;border-radius:11px;background:#fff;color:#37446E;cursor:pointer;white-space:nowrap}',
    '.ud-also__pill.is-on{background:#37446E;border-color:#37446E;color:#fff}',
    '.ud-also__add{margin-top:auto;height:34px;border:1.5px solid #37446E;background:#fff;color:#37446E;font-weight:700;font-size:13px;border-radius:3px;cursor:pointer;width:100%}',
    '.ud-also__add:hover{background:#37446E;color:#fff}',
    '.ud-also__spacer{height:8px}',
    '@media (max-width:768px){.ud-also__nav{display:none}.ud-also__card{flex:0 0 46%}}'
  ].join('');

  // through the bridge (UDCart, else Rebuy Smart Cart, else theme drawer / cart page); old path if it is missing
  function addItems(items, src) {
    if (window.UDCartBridge) return window.UDCartBridge.add(items, src);
    return fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); });
  }
  function openCart() {
    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    if (window.UDCartBridge) { window.UDCartBridge.open(); return; }
    var R = window.Rebuy;
    var open = function () { try { if (R && R.SmartCart && R.SmartCart.show) R.SmartCart.show(); } catch (e) {} };
    try {
      if (R && R.Cart && R.Cart.fetchCart) { var pr = R.Cart.fetchCart(); if (pr && pr.then) pr.then(open, open); else setTimeout(open, 300); }
      else open();
    } catch (e) { open(); }
  }

  // ---------- product card rows under the product (Simon 2026-10-02) ----------
  // One component for "Customers also bought", "More from <collection>" and "Recently viewed":
  // up to 12 cards, best-selling format preselected, mini format pills, price per 100 ml,
  // only formats the customer's region can ship, Add to cart opens the cart.
  var SHOWN = {}; // English handles already shown above (bundle, previous rows): no repeats
  function enOf(h) { if (FR) { for (var en in FRMAP) if (FRMAP[en] === h) return en; } return h; }
  function cardRow(titleHtml, handles, facts, src) {
    return Promise.all(handles.map(function (h) { return getJSON(ROOT + 'products/' + loc(h) + '.js').then(regionalize).catch(function () { return null; }); }))
      .then(function (ps) {
        var models = [];
        ps.forEach(function (p, k) {
          if (!p || !p.available) return;
          var v = pickVariant(p, facts, handles[k]); if (!v) return;
          models.push({ p: p, en: handles[k], v: v });
        });
        if (models.length < 3) return null;
        models.forEach(function (m) { SHOWN[m.en] = 1; });
        function cardInner(m) {
          var p = m.p, v = m.v, src = (v.featured_image && v.featured_image.src) || p.featured_image;
          var sale = v.compare_at_price > v.price, f = facts[m.en], unit = '';
          if (f && f[0]) unit = '$' + (v.price / 100 / ((packCount(v.title) || 1) * f[0]) * 100).toFixed(2) + ' / 100 ml';
          var pills = p.variants.filter(function (x) { return x.available; }).map(function (x) {
            return '<button type="button" class="ud-also__pill' + (x.id === v.id ? ' is-on' : '') + '" data-pv="' + x.id + '">' + label(x.title) + '</button>';
          }).join('');
          var q = p.title.replace(/"/g, '&quot;');
          return '<a class="ud-also__img" href="' + ROOT + 'products/' + p.handle + '"><img src="' + img(src, 360) + '" alt="' + q + '" loading="lazy"></a>' +
            '<a class="ud-also__name" href="' + ROOT + 'products/' + p.handle + '">' + p.title + '</a>' +
            '<div class="ud-also__price' + (sale ? ' is-sale' : '') + '"><span>' + money(v.price) + '</span>' + (sale ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '</div>' +
            '<div class="ud-also__fmt">' + unit + '</div>' +
            '<div class="ud-also__pills">' + pills + '</div><div class="ud-also__spacer"></div>' +
            '<button type="button" class="ud-also__add" data-v="' + v.id + '">' + T.addShort + '</button>';
        }
        var wrap = document.createElement('div');
        wrap.className = 'ud-also ud-pdp-section';
        wrap.innerHTML = '<div class="ud-also__head"><h2 class="ud-also__title ud-pdp-section__title">' + titleHtml + '</h2>' +
          '<div class="ud-also__nav"><button type="button" data-d="-1" aria-label="Previous">&#8249;</button><button type="button" data-d="1" aria-label="Next">&#8250;</button></div></div>' +
          '<div class="ud-also__row">' + models.map(function (m, i) { return '<div class="ud-also__card" data-i="' + i + '">' + cardInner(m) + '</div>'; }).join('') + '</div>';
        var row = wrap.querySelector('.ud-also__row');
        wrap.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          if (b.hasAttribute('data-d')) { row.scrollBy({ left: +b.getAttribute('data-d') * (row.clientWidth - 40), behavior: 'smooth' }); return; }
          if (b.hasAttribute('data-pv')) {
            var card = b.closest('.ud-also__card'), m = models[+card.getAttribute('data-i')], id = +b.getAttribute('data-pv');
            m.v = m.p.variants.filter(function (x) { return x.id === id; })[0] || m.v;
            card.innerHTML = cardInner(m);
            return;
          }
          if (b.classList.contains('ud-also__add')) {
            b.disabled = true; b.textContent = T.adding;
            addItems([{ id: +b.getAttribute('data-v'), quantity: 1 }], src)
              .then(function () { b.textContent = T.added; openCart(); setTimeout(function () { b.disabled = false; b.textContent = T.addShort; }, 1800); })
              .catch(function () { b.disabled = false; b.textContent = T.addShort; });
          }
        });
        return wrap;
      });
  }
  // put our row inside a theme section, in place of its product grid (the section keeps its spot)
  function replaceSection(sec, row) {
    [].forEach.call(sec.children, function (c) { c.style.display = 'none'; });
    sec.appendChild(row);
  }

  function startAlso(alsoLists, facts, skip) {
    if (FR) { for (var en in FRMAP) if (FRMAP[en] === HANDLE) { HANDLE = en; break; } }
    skip.forEach(function (h) { SHOWN[h] = 1; });
    SHOWN[HANDLE] = 1;
    var raw = alsoLists && alsoLists[HANDLE];
    var reg = region();
    var handles = (raw || []).map(function (x) { var a = x.split('|'); return { h: a[0], r: a[1] || '' }; })
      .filter(function (x) { return !SHOWN[x.h] && (!x.r || !reg || (x.r === 'e' ? reg === 'east' : reg === 'west')); })
      .map(function (x) { return x.h; }).slice(0, 12);
    var p1 = handles.length >= 3 ? cardRow(T.also, handles, facts, 'also').then(function (el) {
      if (!el) return;
      // Simon 2026-10-03: Customer Reviews now sit right under the product (templates/product.json),
      // so the carousels start after them: this row goes just before "More like this".
      var more = document.querySelector('[id$="__more-products-collection"]');
      var sec = document.querySelector('[id^="shopify-section-template"][id$="__main"]');
      if (more) more.parentNode.insertBefore(el, more);
      else if (sec) sec.parentNode.insertBefore(el, sec.nextSibling);
    }) : Promise.resolve();
    // then "More from <collection>" (12 products of that collection, not the theme's 5) and "Recently viewed"
    // "Based on your browsing" waits for "More like this" so it never repeats one of its products.
    var rest = function () { upgradeRecent(facts); Promise.resolve(upgradeMore(facts)).then(function () { upgradeBrowsing(facts); }); };
    p1.then(rest, rest);
  }

  function upgradeMore(facts) {
    var sec = document.querySelector('[id$="__more-products-collection"]');
    if (!sec) return;
    var link = sec.querySelector('.section-header a[href*="/collections/"]');
    var title = sec.querySelector('.section-header__title');
    var m = link && link.getAttribute('href').match(/\/collections\/([^\/?#]+)/);
    if (!m) return;
    // Simon 2026-10-03: "More like this" = the product's category collection (sections/more-products-collection.liquid
    // lists up to 3 candidates, smallest first). In-stock products first, current product and products already
    // shown above are skipped; when a candidate gives fewer than 3 cards, the next one is tried.
    var hdr = sec.querySelector('[data-ud-cands]');
    var cands = ((hdr && hdr.getAttribute('data-ud-cands')) || '').split(',').filter(Boolean);
    if (!cands.length) cands = [m[1]];
    var titleHtml = title ? title.innerHTML : '';
    var tryNext = function (i) {
      if (i >= cands.length) return;
      return getJSON(ROOT + 'collections/' + cands[i] + '/products.json?limit=60').then(function (d) {
        var ps = (d.products || []).map(function (p, k) {
          var inStock = (p.variants || []).some(function (v) { return v.available; });
          return { h: enOf(p.handle), s: inStock ? 0 : 1, k: k };
        }).sort(function (a, b) { return a.s - b.s || a.k - b.k; });
        var handles = ps.map(function (x) { return x.h; }).filter(function (h) { return !SHOWN[h]; }).slice(0, 12);
        if (handles.length < 3) return tryNext(i + 1);
        return cardRow(titleHtml, handles, facts, 'more-like-this').then(function (el) { if (el) replaceSection(sec, el); else return tryNext(i + 1); });
      }, function () { return tryNext(i + 1); });
    };
    return Promise.resolve(tryNext(0)).catch(function () {});
  }

  function upgradeRecent(facts) {
    var sec = document.querySelector('[id$="__recently-viewed"]');
    if (!sec) return;
    var done = false;
    var tryIt = function () {
      if (done) return;
      var hs = [];
      sec.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        var mm = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
        if (mm) { var h = enOf(decodeURIComponent(mm[1])); if (h !== HANDLE && hs.indexOf(h) < 0) hs.push(h); }
      });
      if (hs.length < 3) return;
      done = true; obs.disconnect();
      var title = sec.querySelector('.section-header__title');
      cardRow(title ? title.innerHTML : 'Recently viewed', hs.slice(0, 12), facts, 'recent').then(function (el) { if (el) replaceSection(sec, el); });
    };
    var obs = new MutationObserver(tryIt);
    obs.observe(sec, { childList: true, subtree: true });
    tryIt();
  }

  // ---------- "Based on your browsing" (Simon 2026-10-16: "check what type of product they like based on their
  // cart and clicks, and show the best selling of that collection") ----------
  // The shopper's top category from their cart (x3) and recently viewed products (theme localStorage
  // 'recently-viewed', product IDs), not counting this page; then that category collection in Shopify's
  // best-selling order (templates/collection.ud-best.liquid), minus the cart and what the rows above show.
  // Fewer than 2 products of history = no row (a first visit already has "More like this").
  // A/B (review 2026-11-16): localStorage 'ud_bb' A = row, B = no row, 50/50; the group goes on the cart as
  // the attribute ud_browsing_row so orders can be split. Kill switch: window.UD_BROWSING_OFF = true.
  var BB_CATS = { 'Beer': ['beers', 'Non-Alcoholic Beer', 'bière sans alcool'], 'Wine': ['alcohol-free-wines', 'Non-Alcoholic Wine', 'vin sans alcool'],
    'Wine Alternative': ['alcohol-free-wines', 'Non-Alcoholic Wine', 'vin sans alcool'], 'Spirit': ['alcohol-free-spirit', 'Non-Alcoholic Spirits', 'spiritueux sans alcool'],
    'Ready-to-Drink': ['ready-to-drink', 'Ready-to-Drink', 'prêts-à-boire'], 'Cider': ['cider', 'Non-Alcoholic Cider', 'cidre sans alcool'],
    'Coffee & Tea': ['coffee-tea', 'Coffee & Tea', 'café et thé'], 'Natural Energy Drink': ['energy', 'Energy', 'énergie'],
    'Soda': ['soda', 'Soda & Water', 'sodas et eaux'], 'Water': ['soda', 'Soda & Water', 'sodas et eaux'], 'Mixology': ['mixology', 'Mixology', 'mixologie'] };
  function bbGroup() {
    var g = '';
    try { g = localStorage.getItem('ud_bb') || ''; if (g !== 'A' && g !== 'B') { g = Math.random() < 0.5 ? 'A' : 'B'; localStorage.setItem('ud_bb', g); } } catch (e) { g = 'A'; }
    try {
      if (!sessionStorage.getItem('ud_bb_sent')) {
        sessionStorage.setItem('ud_bb_sent', '1');
        fetch(ROOT + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { ud_browsing_row: g } }) }).catch(function () {});
      }
    } catch (e) {}
    return g;
  }
  function upgradeBrowsing(facts) {
    if (window.UD_BROWSING_OFF || bbGroup() !== 'A') return;
    var ids = [];
    try { ids = JSON.parse(localStorage.getItem('recently-viewed') || '[]'); } catch (e) {}
    var here = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && String(ShopifyAnalytics.meta.product.id)) || '';
    ids = ids.map(String).filter(function (id) { return id && id !== here; }).slice(0, 12);
    var cartP = getJSON(ROOT + 'cart.js').catch(function () { return { items: [] }; });
    var typesP = ids.length ? getJSON('/search?view=ud-types&type=product&q=' + encodeURIComponent(ids.map(function (id) { return 'id:' + id; }).join(' OR ')))
      .then(function (d) { return (d && d.t) || {}; }).catch(function () { return {}; }) : Promise.resolve({});
    Promise.all([cartP, typesP]).then(function (r) {
      var cart = r[0].items || [], types = r[1], score = {}, n = 0;
      cart.forEach(function (it) { if (BB_CATS[it.product_type]) { score[it.product_type] = (score[it.product_type] || 0) + 3; n++; } });
      ids.forEach(function (id) { var t = types[id]; if (BB_CATS[t]) { score[t] = (score[t] || 0) + 1; n++; } });
      var best = Object.keys(score).sort(function (a, b) { return score[b] - score[a]; })[0];
      if (!best || n < 2) return;
      var cat = BB_CATS[best];
      var inCart = cart.map(function (it) { return enOf(it.handle); });
      return getJSON('/collections/' + cat[0] + '?sort_by=best-selling&view=ud-best').then(function (hs) {
        var handles = (hs || []).filter(function (h) { return !SHOWN[h] && h !== HANDLE && inCart.indexOf(h) < 0; }).slice(0, 12);
        if (handles.length < 3) return;
        var title = FR ? 'Selon votre navigation <span class="ud-bb__sub">· Les plus vendus en ' + cat[2] + '</span>'
                       : 'Based on your browsing <span class="ud-bb__sub">· Best sellers in ' + cat[1] + '</span>';
        return cardRow(title, handles, facts, 'browsing').then(function (el) {
          if (!el) return;
          var more = document.querySelector('[id$="__more-products-collection"]');
          var rev = document.querySelector('[id^="shopify-section-template"]:has(.jdgm-review-widget)');
          if (more) more.parentNode.insertBefore(el, more.nextSibling);
          else if (rev) rev.parentNode.insertBefore(el, rev);
        });
      });
    }).catch(function () {});
  }
  var cssBrowsing = '.ud-bb__sub{font-weight:400;color:#5A6372;font-size:.8em}';

  var ALSO_URL = me && me.getAttribute('data-also');
  Promise.all([getJSON(LISTS_URL).catch(function () { return {}; }), FACTS_URL ? getJSON(FACTS_URL).catch(function () { return {}; }) : Promise.resolve({}),
               ALSO_URL ? getJSON(ALSO_URL).catch(function () { return {}; }) : Promise.resolve({})])
    .then(function (r) {
      var st = document.createElement('style'); st.textContent = css + cssSection + cssAlso + cssBrowsing; document.head.appendChild(st);
      var go = function () {
        start(r[0], r[1]).then(function (shown) { startAlso(r[2], r[1], shown || []); }, function () { startAlso(r[2], r[1], []); });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
    }).catch(function () {});
})();
